jQuery(document).ready(function($) {
  if ($("main.home").length) {
    console.log("This is the ", "Homepage");

    /*****************************************************************
      Timeout to add animation class
    ******************************************************************/

    window.setTimeout(function() {
      $(".wiper").addClass("start");
    }, 1000); //<-- Delay in milliseconds

    $(window).load(function() {
      // executes when complete page is fully loaded to give time for SVG to render
      TweenMax.to($("#Left_Arrow"), 1, {
        x: -15,
        yoyo: true,
        repeat: -1,
        transformOrigin: "50% 50%"
      });
      TweenMax.to($("#Right_Arrow"), 1, {
        x: 15,
        yoyo: true,
        repeat: -1,
        transformOrigin: "50% 50%"
      });
    });

    // Scroll to Latest Properties Section
    $(".hero-video .down-arrow").on("click", function(e) {
      e.preventDefault();
      var $target = $(".latest-properties");
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top
          },
          500,
          "swing"
        );
    });

    var smcontroller = new ScrollMagic.Controller();

    // Home Hero Slider
    // ---
    var $heroSlider = $(".hero-slider .owl-carousel");
    $heroSlider
      .owlCarousel({
        autoplay: true,
        autoplayTimeout: 15000,
        autoplaySpeed: 400,
        autoplayHoverPause: true,
        loop: true,
        nav: false,
        items: 1,
        singleItem: true,
        rewind: true,
        rewindNav: true,
        rewindSpeed: 0,
        dots: true,
        autoHeight: true,
        lazyLoad: true,
        responsive: {
          950: {
            //autoHeight: false
          }
        }
      })
      .on("changed.owl.carousel", function(event) {
        var index = event.item.index - 1,
          count = event.item.count,
          $bgs = $(".bgs >.container").children();

        if (event.item) {
          if (index > count) {
            index -= count;
          }
          if (index <= 0) {
            index += count;
          }
          //return index;
        }

        $heroSlider.trigger("stop.owl.autoplay"); // resets the autoplay when
        $heroSlider.trigger("play.owl.autoplay"); // user performs any actions
        $($bgs).removeClass("active");
        $($bgs[index - 1]).addClass("active");
      });
    // END Home slider

    // Our Communities Slider
    // ---

    var $ourComm = $(".our-communities .owl-carousel");
    $ourComm
      .owlCarousel({
        autoplay: false,
        items: 1,
        singleItem: true,
        dots: false,
        autoHeight: true,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        responsive: {
          950: {
            autoHeight: false
          }
        }
      })
      .on("changed.owl.carousel", function(event) {
        var current = event.item.index - event.relatedTarget._clones.length / 2,
          allItems = $(".owl-dots").children().length - 1,
          $images = $(".our-communities .images").children(),
          $titleBtns = $(".our-communities .title")
            .children()
            .children("button"),
          $icons = $(".our-communities .icons").children();

        // Fix for when the Owl Carousel has loop:true & clones .owl-items,
        // which messes up its index when goes from last to first.
        if (current > allItems || current == 0) {
          current = 0;
        }

        $($images).removeClass("active");
        $($titleBtns).removeClass("active");
        $($icons).removeClass("active");
        $($images[current]).addClass("active");
        $($titleBtns[current]).addClass("active");
        $($icons[current]).addClass("active");
      });

    $(".our-communities .title button").click(function(event) {
      var index = $(this).index();
      $ourComm.trigger("to.owl.carousel", index);
    });

    $(".our-communities .icons .icon").click(function(event) {
      var index = $(this).index();
      $ourComm.trigger("to.owl.carousel", index);
    });

    /*****************************************************************
      Latest Properties 
    ******************************************************************/

    var $heroSlider = $(".latest-properties .owl-carousel");
    $heroSlider
      .owlCarousel({
        autoplay: false,
        loop: false,
        nav: true,
        navContainer: ".prop-controls",
        navElement: "div",
        navText: ["", ""],
        items: 1,
        margin: 0,
        singleItem: true,
        rewind: true,
        rewindNav: true,
        rewindSpeed: 0,
        dots: true,
        autoHeight: true,
        lazyLoad: true,
        responsive: {
          768: {
            items: 2,
            margin: 30
          },
          950: {
            items: 3,
            margin: 30
          },
          1200: {
            items: 4,
            margin: 30
          }
        }
      })
      .on("changed.owl.carousel", function(e) {
        $(".click-drag").fadeOut();

        var itemIndex = e.item.index;
        if (itemIndex == 0) {
          $(".click-drag").fadeIn();
        }
      });

    /*****************************************************************
       Showcase Slider 
    ******************************************************************/
    var $showcaseSlider = $(".showcase .owl-carousel");

    $showcaseSlider.on("initialized.owl.carousel", function(e) {
      setTimeout(function() {
        var current = e.item.index;
        var prev = $(e.target)
          .find(".owl-item")
          .eq(current)
          .prev()
          .find(".sc-img")
          .attr("style");

        var prevText = $(e.target)
          .find(".owl-item")
          .eq(current)
          .prev()
          .find(".showcase-slide")
          .attr("data-slide-title");

        var nextText = $(e.target)
          .find(".owl-item")
          .eq(current)
          .next()
          .find(".showcase-slide")
          .attr("data-slide-title");

        var next = $(e.target)
          .find(".owl-item")
          .eq(current)
          .next()
          .find(".sc-img")
          .attr("style");

        $(".prev-text").text(prevText);
        $(".next-text").text(nextText);

        $(".prev-img").attr("style", prev);
        $(".next-img").attr("style", next);

        //console.log(prevText);
      }, 300);
    });

    $showcaseSlider.owlCarousel({
      autoplay: false,
      loop: true,
      nav: true,
      navElement: "div",
      navText: [
        "<div class='prev-img'></div><div class='prev'></div><div class='prev-text lead-b'></div>",
        "<div class='next-img'></div><div class='next'></div><div class='next-text lead-b'></div>"
      ],
      dotsContainer: "#custom-dots",
      items: 1,
      singleItem: true,
      rewind: true,
      rewindNav: true,
      rewindSpeed: 0,
      dots: true,
      autoHeight: true,
      lazyLoad: true,
      responsive: {
        950: {
          //autoHeight: false
        }
      }
    });

    $showcaseSlider.on("changed.owl.carousel", function(e) {
      var current = e.item.index;
      var prev = $(e.target)
        .find(".owl-item")
        .eq(current)
        .prev()
        .find(".sc-img")
        .attr("style");

      var prevText = $(e.target)
        .find(".owl-item")
        .eq(current)
        .prev()
        .find(".showcase-slide")
        .attr("data-slide-title");

      var nextText = $(e.target)
        .find(".owl-item")
        .eq(current)
        .next()
        .find(".showcase-slide")
        .attr("data-slide-title");

      var next = $(e.target)
        .find(".owl-item")
        .eq(current)
        .next()
        .find(".sc-img")
        .attr("style");

      $(".prev-text").text(prevText);
      $(".next-text").text(nextText);

      $(".prev-img").attr("style", prev);
      $(".next-img").attr("style", next);
    });

    $(".owl-dot").click(function() {
      $showcaseSlider.trigger("to.owl.carousel", [$(this).index(), 300]);
    });

    // $(".owl-prev").on("click", function() {
    //   console.log("prev");
    //   $showcaseSlider.trigger("next.owl.carousel", [300]);
    //   return false;
    // });

    // $(".owl-next").on("click", function() {
    //   console.log("next");
    //   $showcaseSlider.trigger("prev.owl.carousel", [300]);
    //   return false;
    // });

    /*****************************************************************
      Hovering slide changing buttons does special effect over images
    ******************************************************************/
    var $images = $(".our-communities .images");

    if ($(window).width() < 950) {
      $(".our-communities .title, .our-commnities .icons")
        .on("touchstart", function() {
          $($images).addClass("hoverstate");
        })
        .on("touchend", function() {
          $($images).removeClass("hoverstate");
        });
    } else {
      $(".our-communities .title, .our-communities .icons").hover(
        function() {
          $($images).addClass("hoverstate");
        },
        function() {
          $($images).removeClass("hoverstate");
        }
      );

      ($icons = $(".our-communities .icons").children()),
        ($btns = $(".our-communities .title .h4").children("button"));

      $(".our-communities .title button, .our-communities .icons .icon").hover(
        function() {
          var me = $(this).index(),
            $parent = $(this).parent();

          if ($parent.hasClass("icons")) {
            $($btns[me]).addClass("hoverstate");
          } else if ($parent.hasClass("h4")) {
            $($icons[me]).addClass("hoverstate");
          }
        },
        function() {
          $($icons).removeClass("hoverstate");
          $($btns).removeClass("hoverstate");
        }
      );
    }
    // END Our Communities slider

    //Our Culture .side on viewport enter
    $(".our-culture .side").each(function() {
      var me = $(this);
      var showFromLeft = new ScrollMagic.Scene({
        triggerElement: this,
        triggerHook: 0.5,
        duration: $(me).outerHeight(true),
        reverse: true
      })
        .setClassToggle(this, "visible")
        /*.on( 'start', function ( event ) {
					$( me ).addClass( 'visible' )
				} )*/
        //.addIndicators()
        .addTo(smcontroller);
    });

    // Our Culture .culture-group
    $(".our-culture .culture-group").mouseenter(function() {
      var $me = $(this),
        i = $(this).index(),
        $allChildren = $(this)
          .parent()
          .children();

      if ($me.hasClass("active")) {
        // do nothing
      } else {
        $($allChildren).removeClass("active");
        $($me).addClass("active");
      }
    });

    // Our Communities Slider
    // ---

    var $logos = $(".logo-slider .owl-carousel");
    $logos
      .owlCarousel({
        autoplay: false,
        autoplayTimeout: 15000,
        autoplaySpeed: 400,
        dots: true,
        autoHeight: true,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: false,
        responsive: {
          0: {
            items: 2,
            slideBy: 1
          },
          768: {
            items: 3,
            slideBy: 2
          },
          950: {
            items: 5,
            slideBy: 3
          }
        }
      })
      .on("changed.owl.carousel", function(event) {
        $logos.trigger("stop.owl.autoplay"); // resets the autoplay when
        $logos.trigger("play.owl.autoplay"); // user performs any actions
      });
    // END Our Communities Slider
  }
});
